// On DOMContentLoaded, set dynamic left position for each .mb-back-button using jQuery

jQuery(function ($) {
  function setDynamicLeft($button) {
    if (window.innerWidth > 1280) {
      var leftPx = window.innerWidth * -0.05;
      $button.css('left', leftPx + 'px');
      console.log('Set dynamic left:', leftPx + 'px');
    } else {
      $button.css('left', ''); // Remove inline style, let CSS handle
      console.log('Reset left to CSS');
    }
  }

  function handleResize() {
    $('.mb-back-button').each(function () {
      var $button = $(this);
      setDynamicLeft($button);
    });
  }

  // Initial run
  handleResize();
  // On resize
  $(window).on('resize', handleResize);
});
